// Map Latin lookalike characters to Greek equivalents (both cases)
const LATIN_TO_GREEK = {
  'A': 'Α', 'B': 'Β', 'E': 'Ε', 'H': 'Η', 'I': 'Ι', 'K': 'Κ',
  'M': 'Μ', 'N': 'Ν', 'O': 'Ο', 'P': 'Ρ', 'T': 'Τ', 'X': 'Χ',
  'Y': 'Υ', 'Z': 'Ζ',
  'a': 'α', 'b': 'β', 'e': 'ε', 'h': 'η', 'i': 'ι', 'k': 'κ',
  'n': 'ν', 'o': 'ο', 'p': 'ρ', 't': 'τ', 'v': 'ν', 'x': 'χ',
  'y': 'υ', 'z': 'ζ',
};

/**
 * Normalize a string by replacing Latin lookalike chars with Greek equivalents.
 * Used for search and sorting of Greek text that may contain Latin chars.
 */
export const normalizeGreek = (str) => {
  if (!str) return '';
  return str.split('').map(ch => LATIN_TO_GREEK[ch] || ch).join('');
};
